import { Controller } from "@hotwired/stimulus"

export default class AttributeController extends Controller {
  static values = { 
    status: Boolean,
    attributeName: String
  }

  toggle() {
    this.flipState()
  }

  flipState() {
    this.statusValue = !this.statusValue
  }

  statusValueChanged() { 
    this.updateAttribute()
  }

  updateAttribute() {
    this.element.setAttribute(this.attributeNameValue, String(this.statusValue)) 
  }
}